export default {
  meta: {
    title: '飞书登录',
  },
};
